// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBar_search__26Ldp","btn_Search":"SearchBar_btn_Search__1r-ng","titulo_buscar":"SearchBar_titulo_buscar__1_DIG"};